export const OPTHINES = {
  voteName: '2020project/2020openjune',
  mustSearch: 'Button',
  number: {
    mustRank: false,
  },
  themeColor: {
    activeBgColor: 'rgb(187, 211, 220)',
    inactiveBgColor: 'rgb(187, 211, 220)',
  },
  tabs: [
    {
      tabName: '直播间',
      tabPath: 'http://www.baidu.com',
    },
    {
      tabName: '创作故事',
      tabPath: '/20200511OPENJUN/Rules',
    },
    {
      tabName: '互动话题',
      tabPath: '/20200511OPENJUN/News',
    },
  ],
};
